<div class="processing-history-table-wrapper">
  <h1 class="title">{{ "sources.General.ProcessingHistory" | translate }}</h1>

  <ng-template #tableContent>
    <div class="table-place">
      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="StartDateUtc">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.processingHistory.columns.startTime" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            {{ process.StartDateUtc | date: "MMM dd, YYYY hh:mm a" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="EndDateUtc">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.processingHistory.columns.finishTime" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            {{ process.EndDateUtc | date: "MMM dd, YYYY hh:mm a" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Duration">
          <mat-header-cell *matHeaderCellDef>
            {{ "all-reports.data-processing.table.columns.duration" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            {{ getProcessDuration(process) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.tableOftenColumns.status" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            <div class="process-status">
              <mee-process-status [currentProcessStatus]="process.Status"></mee-process-status>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Progress">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.tableOftenColumns.percent" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            <ng-container *ngIf="getIsShowProgress(process)">
              {{ this.getProcessProgress(process) }}
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="InitiatorName">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.processingHistory.columns.initializedBy" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            {{ process.InitiatorName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DataSourceType">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ "sources.scheduling.processingHistory.columns.type" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let process">
            {{ getSourceType(process) }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="viewProcessDetails(row)"></mat-row>
      </mat-table>
    </div>
  </ng-template>

  <!--TODO replace with mee-stub component-->

  <ng-container *ngIf="processingHistoryProcesses?.length === 0 && !isDataLoading; else tableContent">
    <div class="empty-list-wrapper">
      <div class="empty-list">
        <img src="assets/img/icons/empty-list.png" alt="" />
        <h1>{{ "all-reports.data-processing.table.emptyListErrorText" | translate | uppercase }}</h1>
      </div>
    </div>
  </ng-container>
</div>
